import { render, staticRenderFns } from "./stored-consum-statistics.vue?vue&type=template&id=15d6af84"
import script from "./stored-consum-statistics.vue?vue&type=script&lang=js"
export * from "./stored-consum-statistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports